import { Box, Tooltip, Typography } from '@mui/material'
import React from 'react'
import { useLocation, useNavigate } from 'react-router'
import { getStyles } from '../../utils/utils/commonUtils'
import { getComp } from '../../utils/utils/DI'
import { orderInfoChipsStyles } from './orderInfoChipsStyles'

const OrderInfoChips = ({
  id,
  reportStatus,
  tooltip,
  haveChips,
  propsStyle,
  showOrderStatusIcon,
  pointer,
  preventClick = false,
}) => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const classes = getStyles(orderInfoChipsStyles)
  const statusStore = getComp('StatusesStore')

  const openReportDetailsCallback = () => {
    if (!pathname.includes('/reports') && !preventClick)
      navigate(`/reports/${id}`)
  }

  const statusImage = statusStore.getReportStatusImage(reportStatus, true)

  return (
    <Box
      mx={2}
      sx={{
        ...classes.container,
        background: haveChips ? 'rgb(237 241 245)' : null,
        ...propsStyle,
      }}
    >
      {showOrderStatusIcon && reportStatus && (
        <Tooltip title={tooltip} placement={'top-start'}>
          <img
            style={{ width: '20px', height: '20px', marginBottom: '1px' }}
            alt={`report status №${reportStatus}`}
            src={statusImage}
          />
        </Tooltip>
      )}
      <Typography
        sx={{
          ...classes.text,
          color: pointer ? '#0871C3' : '#4e4e4e',
          cursor: pointer ? 'pointer' : 'default',
          textDecoration: pointer ? 'underline' : 'none',
        }}
        onClick={openReportDetailsCallback}
      >
        {id}
      </Typography>
    </Box>
  )
}

export default OrderInfoChips
